import { createResource, type RouteResource } from 'react-resource-router';

import { getGroupFeatureStatus } from '../endpoint';
import { type AlertGroupFeatureStateResponse } from '../types';

const emptyAlertGroupingState = {
	isEnabled: false,
	reason: null,
};

export const alertGroupingStateResource: RouteResource<AlertGroupFeatureStateResponse> =
	createResource<AlertGroupFeatureStateResponse>({
		type: 'alertGroupingStateResource',
		getKey: () => 'alertGroupingStateResource',
		getData: async () => {
			try {
				const response = await getGroupFeatureStatus();
				return response;
			} catch (e) {
				// Exception handling and to return emptyState
				return emptyAlertGroupingState;
			}
		},
		maxAge: 5 * 60 * 1000, // 5 minutes
		isBrowserOnly: true,
	});
